import type { ReactNode } from 'react';
import { Text } from '@folio/components/ui/text';

export function StopAlertLayout({ icon, children }: { icon: ReactNode; children: ReactNode }) {
  return (
    <span className="flex items-start gap-4">
      {icon}
      <Text inline weight="normal" className="flex flex-col gap-1">
        {children}
      </Text>
    </span>
  );
}

export function StopAlertMessage({
  lead,
  body,
  meta,
}: {
  lead: string;
  body: string;
  meta: string;
}) {
  return (
    <>
      <span>
        <Text inline weight="medium">
          {lead}
        </Text>{' '}
        {body}
      </span>
      <span>{meta}</span>
    </>
  );
}
